var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgCalendarV2 = function SvgCalendarV2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    y: 1.8,
    width: 16.2,
    height: 16.2,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.7 0v3.6M4.5 0v3.6M0 7.2h16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 8h16v9H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-monochrome-white)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5 10.8h.009M8.1 10.8h.009M11.7 10.8h.009M4.5 14.4h.009M8.1 14.4h.009M11.7 14.4h.009"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarV2);
export default ForwardRef;